import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { cardCls, fmtDateTime } from "./ui";

export const AuditSection = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/admin/audit").then((r) => setItems(r.data.items)).catch(() => {});
  }, []);

  return (
    <div className={cardCls} data-testid="admin-audit-section">
      {items.length === 0 && <p className="px-5 py-10 text-sm text-midnight/40">No recorded admin actions yet.</p>}
      {items.map((a) => (
        <div key={a.id} className="flex flex-wrap items-center gap-x-6 gap-y-1 px-5 py-3.5 border-b border-midnight/[0.06]">
          <span className="text-xs text-midnight/45 w-40 shrink-0">{fmtDateTime(a.ts)}</span>
          <span className="text-xs font-medium text-midnight">{a.actor}</span>
          <span className="text-[11px] font-bold uppercase tracking-wide text-gold">{a.action}</span>
          <span className="text-xs text-midnight/50">{a.detail}</span>
        </div>
      ))}
    </div>
  );
};
